export default function auth({ store, next }) {
  if (!store.state.auth.isAuthenticated) {
    return next({
      name: 'Login'
    })
  }
  return next()
}
